import React from "react";

interface Props {
  color?: string;
  size?: string;
  tickStroke?: string;
  tickColor?: string;
}
export default function Tick({ color, size, tickStroke, tickColor }: Props) {
  return (
    <svg
      width={size ?? "24px"}
      height={size ?? "24px"}
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink">
      <g id="Designs" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Mobile---Profile" transform="translate(-357.000000, -1087.000000)">
          <g id="Authorised-users" transform="translate(22.000000, 991.000000)">
            <g id="Listing-1" transform="translate(25.000000, 95.000000)">
              <g id="Group" transform="translate(310.000000, 1.000000)">
                <circle id="Oval" fill={color ?? "#01C0AA"} cx="12" cy="12" r="12"></circle>
                <g
                  transform="translate(7.000000, 9.000000)"
                  id="Icons-/-Line-/-Tick"
                  stroke={tickColor ?? "#FFFFFF"}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={tickStroke ?? "1.25"}>
                  <g>
                    <polyline id="Path" points="0 3.5 3.3335 7 10 0"></polyline>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
